const HOST = process.env.REACT_APP_HOST;
const IMAGE_HOST = process.env.REACT_APP_IMAGE_HOST;
const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY ?? "";

export { HOST, IMAGE_HOST, GOOGLE_MAPS_KEY };
